import * as React from 'react'
import { cn } from '@/lib/utils'

function Textarea({ className, ...props }: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'min-h-20 w-full rounded-sm border border-line-strong bg-surface px-3 py-2 text-sm text-fg',
        'placeholder:text-fg-muted',
        'transition-colors hover:border-line-strong',
        'disabled:cursor-not-allowed disabled:opacity-60',
        'aria-[invalid=true]:border-danger',
        className,
      )}
      {...props}
    />
  )
}

export { Textarea }
